const UrlApi = {
  baseUrl: process.env.REACT_APP_BASEURL,
  baseUrlImage: process.env.REACT_APP_BASEURLIMAGE,

  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    signup: "auth/signup",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
    changePassword: "auth/change-password",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
  },
  contact: {
    get: "contact_us/get",
  },

  admin_logs: {
    get: "admin_logs/get",
    edit: "admin_logs/edit",
  },
  settings: {
    get: "settings/get",
    edit: "settings/update_settings",
  },
  reOrder: "reorder",

  advocacy: {
    get: "advocacy/get",
    add: "advocacy/add",
    edit: "advocacy/edit",
    delete: "advocacy/delete",
  },

  advocacy_category: {
    get: "advocacy_category/get",
    add: "advocacy_category/add",
    edit: "advocacy_category/edit",
    delete: "advocacy_category/delete",
  },

  in_press_category: {
    get: "in_press_category/get",
    add: "in_press_category/add",
    edit: "in_press_category/edit",
    delete: "in_press_category/delete",
  },

  in_press: {
    get: "in_press/get",
    add: "in_press/add",
    edit: "in_press/edit",
    delete: "in_press/delete",
  },

  political_mission: {
    get: "political_mission/get",
    add: "political_mission/add",
    edit: "political_mission/edit",
    delete: "political_mission/delete",
  },

  political_mission_category: {
    get: "political_mission_category/get",
    add: "political_mission_category/add",
    edit: "political_mission_category/edit",
    delete: "political_mission_category/delete",
  },

  publication: {
    get: "publication/get",
    add: "publication/add",
    edit: "publication/edit",
    delete: "publication/delete",
  },
  social_lnitiatives: {
    get: "social_lnitiatives/get",
    add: "social_lnitiatives/add",
    edit: "social_lnitiatives/edit",
    delete: "social_lnitiatives/delete",
    getByParentId: "social_lnitiatives/",
  },
  // related_social_lnitiatives: {
  //   get: "related_social_lnitiatives/get",
  //   add: "related_social_lnitiatives/add",
  //   edit: "related_social_lnitiatives/edit",
  //   delete: "related_social_lnitiatives/delete",
  // },

  seo: {
    get: "seo/get",
    edit: "seo/edit",
  },
  Gallery: {
    get: "gallery/get",
    add: "gallery/add",
    edit: "gallery/edit",
    delete: "gallery/delete",
  },
  upload: "gallery/upload",
};

export default UrlApi;
